import { AjaxService } from "../shared/services/AjaxService";
import { ResponseModel } from "../models/ResponseModel";

import {
  ChantingDto,
  ChantingFilterDto,
} from "../models/ChantingModels";

/* ================= SERVICE ================= */

export const ChantingService = {

  // 🔹 Get entry for selected date
  async getAgainstDate(date: string): Promise<ResponseModel> {
    return AjaxService.post<ResponseModel>(
      "/Chanting/getChantingAgainstDate",
      { date }
    );
  },

  // 🔹 Create
  async create(payload: ChantingDto): Promise<ResponseModel> {
    return AjaxService.post<ResponseModel>(
      "/Chanting/create",
      payload
    );
  },

  // 🔹 Update
  async update(payload: ChantingDto): Promise<ResponseModel> {
    return AjaxService.put<ResponseModel>(
      "/Chanting/update",
      payload
    );
  },

  // 🔹 History
  async history(payload: ChantingFilterDto): Promise<ResponseModel> {
    return AjaxService.post<ResponseModel>(
      "/Chanting/getChantingHistory",
      payload
    );
  },

  // 🔹 Get single entry
  async get(chantingId: string): Promise<ResponseModel> {
    return AjaxService.get<ResponseModel>(
      `/Chanting/getChanting?chantingId=${encodeURIComponent(chantingId)}`
    );
  },

  // 🔹 Delete entry
  async delete(chantingId: string): Promise<ResponseModel> {
    return AjaxService.delete<ResponseModel>(
      `/Chanting/delete?chantingId=${encodeURIComponent(chantingId)}`
    );
  },

};